/**
 * Show a person's display name, falling back to whatever we have. The API stamps a display name
 * at write time; legacy records created before that may only have the raw id (a UUID). Prefer the
 * name; if absent, show the id so the field is never blank.
 */
export function personName(
  name: string | null | undefined,
  fallbackId?: string | null,
): string {
  const n = name?.trim();
  if (n) return n;
  return fallbackId?.trim() || 'Unknown';
}
